import { getDatepickerConfig } from "@app/directives/input-directives/bs-datepicker.config";
var ɵ0 = getDatepickerConfig;
var DirectivesModule = /** @class */ (function () {
    function DirectivesModule() {
    }
    return DirectivesModule;
}());
export { DirectivesModule };
export { ɵ0 };
